package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class CenterInterestState(
    val id: String,
    center_interest: String = ""
) {
    var center_interest by mutableStateOf(center_interest)
}
